/**
 * Active Indicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ActiveIndicatorItemRequestDto { 
    indicatorId: string;
    /**
     * Nível societário alvo para monitoramento do indicador.
     */
    relationshipLevel: ActiveIndicatorItemRequestDto.RelationshipLevelEnum;
}
export namespace ActiveIndicatorItemRequestDto {
    export const RelationshipLevelEnum = {
        Root: 'ROOT',
        L1: 'L1',
        L2: 'L2'
    } as const;
    export type RelationshipLevelEnum = typeof RelationshipLevelEnum[keyof typeof RelationshipLevelEnum];
}


